import { defineMessages } from 'react-intl';

export const sharedMessages = defineMessages({
  advanced: {
    id: 'shared.advanced',
    defaultMessage: 'Advanced',
  },
  expert: {
    id: 'shared.expert',
    defaultMessage: 'Expert',
  },
  query: {
    id: 'shared.query',
    defaultMessage: 'Query',
  },
  advancedSearch: {
    id: 'shared.advancedSearch',
    defaultMessage: 'Advanced search',
  },
  apply: {
    id: 'shared.apply',
    defaultMessage: 'Apply',
  },
  author: {
    id: 'shared.authorCreator',
    defaultMessage: 'Author/creator',
  },
  barcode: {
    id: 'shared.barcode',
    defaultMessage: 'Library Number or Barcode',
  },
  back: {
    id: 'shared.back',
    defaultMessage: 'Back',
  },
  cancel: {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  cite: {
    id: 'shared.cite',
    defaultMessage: 'Cite',
  },
  copiedToClipboard: {
    id: 'shared.copiedToClipboard',
    defaultMessage: 'Copied to clipboard',
  },
  copyToClipboard: {
    id: 'shared.copyToClipboard',
    defaultMessage: 'Copy to clipboard',
  },
  clear: {
    id: 'shared.clear',
    defaultMessage: 'Clear',
  },
  clearAll: {
    id: 'shared.clearAll',
    defaultMessage: 'Clear all',
  },
  clearResults: {
    id: 'shared.clearResults',
    defaultMessage: 'Clear results',
  },
  close: {
    id: 'shared.close',
    defaultMessage: 'Close',
  },
  department: {
    id: 'shared.department',
    defaultMessage: 'Department',
  },
  description: {
    id: 'shared.description',
    defaultMessage: 'Description',
  },
  dueDate: {
    id: 'shared.dueDate',
    defaultMessage: 'Due {date}',
  },
  endOfList: {
    id: 'resultsList.endOfList',
    defaultMessage: 'End of list',
  },
  externalLink: {
    id: 'shared.externalLink',
    defaultMessage: '(link opens in new tab)',
  },
  error: {
    id: 'resultsList.error',
    defaultMessage: 'Sorry, no new results can be loaded. Please try again.',
  },
  from: { id: 'shared.from', defaultMessage: 'From' },
  holdCount: {
    id: 'shared.holdCount',
    defaultMessage: '{count, plural, one {# hold} other {# holds}}',
  },
  instructor: { id: 'shared.instructor', defaultMessage: 'Instructor' },
  isbn: { id: 'shared.isbn', defaultMessage: 'ISBN' },
  lccn: { id: 'shared.lccn', defaultMessage: 'LCCN' },
  issn: { id: 'shared.issn', defaultMessage: 'ISSN' },
  keyword: { id: 'shared.keyword', defaultMessage: 'Keyword' },
  language: { id: 'shared.language', defaultMessage: 'Language' },
  loading: { id: 'resultsList.loading', defaultMessage: 'Loading results...' },
  loadingMessage: { id: 'shared.loading', defaultMessage: 'Loading' },
  location: { id: 'shared.location', defaultMessage: 'Location' },
  map: { id: 'shared.map', defaultMessage: 'Map' },
  more: { id: 'shared.more', defaultMessage: 'More' },
  name: { id: 'shared.name', defaultMessage: 'Name' },
  next: { id: 'shared.next', defaultMessage: 'Next' },
  no: { id: 'shared.no', defaultMessage: 'No' },
  of: { id: 'shared.of', defaultMessage: '{number} of {total}' },
  numberOfCourses: {
    id: 'shared.numberOfCourses',
    defaultMessage: 'Course results: {number}',
  },
  numberOfItems: {
    id: 'shared.numberOfItems',
    defaultMessage: 'Number of items: {number}',
  },
  pageNumber: {
    id: 'shared.pageNumber',
    defaultMessage: 'Page {pageNumber}',
  },
  pageUnavailable: {
    id: 'shared.pageUnavailable',
    defaultMessage: 'Page unavailable',
  },
  preferences: {
    id: 'shared.preferences',
    defaultMessage: 'Preferences',
  },
  previous: {
    id: 'shared.previous',
    defaultMessage: 'Previous',
  },
  projects: {
    id: 'shared.projects',
    defaultMessage: 'Projects',
  },
  processingError: {
    id: 'shared.processingError',
    defaultMessage:
      'There was a problem processing the request. Please try again.',
  },
  pleaseTryAgain: {
    id: 'shared.pleaseTryAgain',
    defaultMessage: 'Please try again.',
  },
  pin: {
    id: 'shared.pin',
    defaultMessage: 'PIN',
  },
  plusMore: {
    id: 'shared.plusMore',
    defaultMessage: '+{amount} more',
  },
  publisher: {
    id: 'shared.publisher',
    defaultMessage: 'Publisher',
  },
  refreshPage: {
    id: 'shared.refreshPage',
    defaultMessage: 'Refresh page',
  },
  results: {
    id: 'shared.results',
    defaultMessage: 'Results: {number}',
  },
  resetPin: {
    id: 'shared.resetPin',
    defaultMessage: 'Reset PIN',
  },
  required: {
    id: 'shared.required',
    defaultMessage: 'Required',
  },
  requiredField: {
    id: 'auth.requiredFieldMessage',
    defaultMessage: 'Please provide a {fieldName}',
  },
  requestsAndLoans: {
    id: 'shared.requestsAndLoans',
    defaultMessage: 'Requests & loans',
  },
  save: {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  scrollBackward: {
    id: 'shared.scrollBackward',
    defaultMessage: 'Scroll backward',
  },
  scrollForward: {
    id: 'shared.scrollForward',
    defaultMessage: 'Scroll forward',
  },
  search: {
    id: 'shared.search',
    defaultMessage: 'Search',
  },
  searches: {
    id: 'saved.searches',
    defaultMessage: 'Searches',
  },
  searchInvalidText: {
    id: 'shared.searchInvalidText',
    defaultMessage:
      'Invalid search term or Boolean operator provided in query. Please change your search query and try again.',
  },
  searchUnavailableText: {
    id: 'shared.searchUnavailableText',
    defaultMessage: 'Something went wrong. Try refreshing the page.',
  },
  share: {
    id: 'shared.share',
    defaultMessage: 'Share',
  },
  showLess: {
    id: 'shared.showLess',
    defaultMessage: 'Show less',
  },
  showMoreButtonTitle: {
    id: 'resultsList.showMoreButtonTitle',
    defaultMessage: 'Show more results',
  },
  signIn: {
    id: 'shared.signIn',
    defaultMessage: 'Sign in',
  },
  somethingWentWrong: {
    id: 'shared.somethingWentWrong',
    defaultMessage: 'Something went wrong.',
  },
  somethingWentWrongPleaseTryAgain: {
    id: 'shared.somethingWentWrongPleaseTryAgain',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  somethingWentWrongContactAdmin: {
    id: 'shared.somethingWentWrongContactAdmin',
    defaultMessage:
      'Something went wrong. Please try again or contact your Administrator.',
  },
  sourceType: {
    id: 'shared.sourceType',
    defaultMessage: 'Source type',
  },
  staffView: {
    id: 'shared.staffView',
    defaultMessage: 'Staff view',
  },
  subject: {
    id: 'shared.subject',
    defaultMessage: 'Subject',
  },
  submit: {
    id: 'shared.submit',
    defaultMessage: 'Submit',
  },
  title: {
    id: 'shared.title',
    defaultMessage: 'Title',
  },
  to: {
    id: 'shared.to',
    defaultMessage: 'To',
  },
  unsave: {
    id: 'shared.unsave',
    defaultMessage: 'Unsave',
  },
  welcomeBack: {
    id: 'shared.welcomeBack',
    defaultMessage: 'Welcome back',
  },
  weAreNotAbleToProcessRequest: {
    id: 'shared.weAreNotAbleToProcessRequest',
    defaultMessage:
      'We are not able to process your request. Please try again later.',
  },
  yes: {
    id: 'shared.yes',
    defaultMessage: 'Yes',
  },
  all: {
    id: 'shared.all',
    defaultMessage: 'All',
  },
  searchHistory: {
    id: 'shared.searchHistory',
    defaultMessage: 'Search history',
  },
  records: {
    id: 'saved.records',
    defaultMessage: 'Records',
  },
  recentActivity: {
    id: 'shared.recentActivity',
    defaultMessage: 'Recent activity',
  },
  saved: {
    id: 'shared.saved',
    defaultMessage: 'Saved',
  },
  create: {
    id: 'shared.create',
    defaultMessage: 'Create',
  },
  createNewProject: {
    id: 'shared.createNewProject',
    defaultMessage: 'Create a new project',
  },
  editProject: {
    id: 'shared.editProject',
    defaultMessage: 'Edit project',
  },
  selectOptions: {
    id: 'shared.selectOptions',
    defaultMessage: 'Select options',
  },
  format: {
    id: 'shared.format',
    defaultMessage: 'Format',
  },
  series: {
    id: 'shared.series',
    defaultMessage: 'Series',
  },
  startANewSearch: {
    id: 'shared.startANewSearch',
    defaultMessage: 'Start a new search',
  },
  holdsAndCheckouts: {
    id: 'shared.holdsAndCheckouts',
    defaultMessage: 'Holds & checkouts',
  },
  requestItem: {
    id: 'shared.requestItem',
    defaultMessage: 'Request item',
  },
  placeHold: {
    id: 'shared.placeHold',
    defaultMessage: 'Place hold',
  },
  removeHold: {
    id: 'shared.removeHold',
    defaultMessage: 'Remove hold',
  },
  removeRequest: {
    id: 'shared.removeRequest',
    defaultMessage: 'Remove request',
  },
  publicationYear: {
    id: 'shared.publicationYear',
    defaultMessage: 'Publication year',
  },
  addToProject: {
    id: 'shared.addToProject',
    defaultMessage: 'Add to project',
  },
  callNumber: {
    id: 'shared.callNumber',
    defaultMessage: 'Call number',
  },
  details: {
    id: 'shared.details',
    defaultMessage: 'Details',
  },
  libraryHoldings: {
    id: 'shared.libraryHoldings',
    defaultMessage: 'Library holdings',
  },
  onHold: {
    id: 'shared.onHold',
    defaultMessage: 'On hold',
  },
  or: {
    id: 'shared.or',
    defaultMessage: 'Or',
  },
  status: {
    id: 'shared.status',
    defaultMessage: 'Status',
  },
  itemStatus: {
    id: 'shared.itemStatus',
    defaultMessage: 'Item status',
  },
  termsOfUse: {
    id: 'shared.termsOfUse',
    defaultMessage: 'Terms of use',
  },
  available: {
    id: 'shared.available',
    defaultMessage: 'Available',
  },
  notAvailable: {
    id: 'shared.notAvailable',
    defaultMessage: 'Not available',
  },
  courseReserves: {
    id: 'shared.courseReserves',
    defaultMessage: 'Course reserves',
  },
  note: { id: 'shared.note', defaultMessage: '<b>Note:</b> {note}' },
  infinitePagination: {
    id: 'shared.infinitePagination',
    defaultMessage:
      'There is infinite pagination, allowing users to navigate forward and backward through the result set.',
  },
  keywordDescription: {
    id: 'shared.keywordDescription',
    defaultMessage:
      'Keyword - searches titles, statements, identifiers, authors, publisher information, edition, notes, subjects, classifications, resource types, format, item call numbers.',
  },
  items: { id: 'shared.items', defaultMessage: 'Items' },
  noResultsForTerm: {
    id: 'shared.noResultsForTerm',
    defaultMessage: 'No results for - {term}',
  },
  contributor: { id: 'shared.contributor', defaultMessage: 'Contributor' },
  genre: { id: 'shared.genre', defaultMessage: 'Genre' },
});
